<template>
  <div class="bg-[#011A81]">
    <div class="px-3 md:px-4 sm:px-4 ">
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
    </div>
  </div>
</template>

<script setup>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import {computed, onMounted, ref, watch} from "vue";
const zoomLevel = window.devicePixelRatio;
const screenWidth = computed(() => window.innerWidth);
const screenHeight = computed(() => window.innerHeight);
const biroser=ref('')
const isMode=ref(false);
const widthPx=ref('150px ')
onMounted(()=>{
  document.title='重庆铭匠网络科技'
  biroser.value=getBrowserEngine()
  window.onresize = setRemBase; // 窗口大小改变时重新设置基准值
  setRemBase(); // 初始化设置一次基准值
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log(userAgent)
  isMode.value = /android|iphone|ipad|ipod/i.test(userAgent);
  if (!isMode.value&&window.innerWidth>520){
    //不是手机的情况的下
    widthPx.value='200px '
  }
  document.documentElement.style.setProperty('--child-color', widthPx.value);
  console.log(widthPx.value,'值')
})
window.addEventListener('resize',()=>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  isMode.value = /android|iphone|ipad|ipod/i.test(userAgent);
  if (!isMode.value&&window.innerWidth>520){
    //不是手机的情况的下
    widthPx.value='200px '
  }
  document.documentElement.style.setProperty('--child-color', widthPx.value);
  console.log(widthPx.value,'值',isMode.value)
})

function getBrowserEngine() {
  const userAgent = navigator.userAgent;
  let browserEngine = null;
  if (/Edg\//i.test(userAgent)) {
    browserEngine = "EdgeHTML";
  } else if (/AppleWebKit\//i.test(userAgent)) {
    browserEngine = "AppleWebKit";
  } else if (/Gecko\//i.test(userAgent)) {
    browserEngine = "Gecko";
  } else if (/Trident\//i.test(userAgent)) {
    browserEngine = "Trident";
  } else if (/Blink\//i.test(userAgent)) {
    browserEngine = "Blink";
  }
  return browserEngine;
}


function setRemBase() {
  const baseSize = 9; // 默认基准大小
  const screenWidth = document.documentElement.clientWidth; // 获取屏幕宽度
  const scale = screenWidth / 375; // 假设设计稿宽度为375px，可以根据实际情况调整比例因子
  document.documentElement.style.fontSize = `${baseSize * Math.min(scale, 2)}px`; // 限制最大缩放比例，避免过小或过大
}

</script>
<style>
.el-popover {
  padding: 0.1rem !important;
}
.el-popover.el-popper{
  min-width: var(--child-color,150px) !important;
}
</style>
